import { Controller } from "@hotwired/stimulus"
import { createRoot } from "react-dom/client"
import BookForm from "../components/BookForm"

// Mount point for the new/edit book screen: hands the server-rendered config
// (action, csrf, genres, current values, cover) to the React form.
export default class extends Controller {
  static values = { config: Object }

  connect() {
    this.root = createRoot(this.element)
    this.root.render(<BookForm config={this.configValue} />)
  }

  disconnect() {
    this.root?.unmount()
  }
}
